// 评价日志
<template>
  <a-drawer
    placement="right"
    :visible="visible"
    @close="handleClose"
    wrapClassName="evaluate_log_popover"
    title="评价信息"
    :bodyStyle="{ padding: '0px', backgroundColor: '#F5F5F5' }"
    :width="432"
  >
    <a-spin class="spinning" :spinning="loading">
      <div class="header">
        <div class="item" v-for="item in evaluateColumns" :key="item.key">
          <div class="label">{{ item.label }}</div>
          <div v-if="item.customRender === 'score'" class="val">
            <div class="score">
              <img
                :src="star"
                alt=""
                class="star"
                v-for="it in scoreRange(evaluateData[item.key])"
                :key="it"
              />
              <img
                v-for="it in scoreRange(5 - evaluateData[item.key])"
                :key="it"
                :src="emptyStar"
                alt=""
                class="star"
              />
            </div>
          </div>
          <div v-else>{{ evaluateData[item.key] || '--' }}</div>
        </div>
      </div>
      <div class="log">
        <div class="label">操作日志</div>
        <div class="progress">
          <template v-if="operationLog.length">
            <div class="item" v-for="(it, index) in operationLog" :key="index">
              <div class="left">
                <div class="pointer"></div>
                <div class="line"></div>
              </div>
              <div class="right">
                <div class="time">{{ it.operatedAt }}</div>
                <div class="user">
                  <span>{{ it.content }}</span>
                  {{ it.operatedByName }}
                </div>
              </div>
            </div>
          </template>
          <div v-else>
            <a-empty />
          </div>
        </div>
      </div>
    </a-spin>
  </a-drawer>
</template>
<script setup>
import { ref, defineExpose } from 'vue'
import { evaluateColumns, star, emptyStar } from './config'
import { getEvaluation } from '@/api/workPlace/consult'
import { scoreRange } from '@/utils'

const visible = ref(false)
const loading = ref(false)
const evaluateData = ref({})
const operationLog = ref([])
const getData = evaluationId => {
  if (!evaluationId) return
  getEvaluation({ evaluationId }).then(res => {
    evaluateData.value = res || {}
    operationLog.value = res?.operationLog || []
  })
}
const initModal = item => {
  visible.value = true
  getData(item.id)
}
// 关闭弹窗
const handleClose = () => {
  visible.value = false
}
defineExpose({ initModal })
</script>

<style scoped lang="scss">
.evaluate_log_popover {
  .header {
    padding: 20px 24px;
    background: #ffffff;
    margin-bottom: 10px;
    .item {
      margin-bottom: 12px;
      display: flex;
      flex-direction: row;
      &:last-child {
        margin-bottom: 0;
      }
      .label {
        font-weight: 400;
        font-size: 14px;
        color: #333333;
        width: 80px;
        flex-shrink: 0;
      }
      .val {
        font-weight: 500;
        font-size: 14px;
        color: #333333;
        line-height: 20px;
        .star {
          width: 16px;
          height: 16px;
          margin-right: 2px;
        }
      }
    }
  }
  .log {
    padding: 20px 24px;
    background: #ffffff;
    display: flex;
    flex-direction: row;
    .label {
      font-weight: 400;
      font-size: 14px;
      color: #333333;
      width: 80px;
      flex-shrink: 0;
    }
    .progress {
      .item {
        &:last-child {
          .left .line {
            background: transparent;
          }
        }
        display: flex;
        flex-direction: row;
        .left {
          margin-right: 16px;
          position: relative;
          .pointer {
            width: 7px;
            height: 7px;
            background: #189fff;
            border-radius: 50%;
            margin-top: 5px;
          }
          .line {
            position: absolute;
            top: 13px;
            bottom: -3px;
            width: 1px;
            background: #e6e6e6;
            left: 3px;
          }
        }
        .right {
          .time {
            font-weight: 400;
            font-size: 12px;
            color: #999999;
            line-height: 17px;
            margin-bottom: 4px;
          }
          .user {
            font-weight: 400;
            font-size: 12px;
            color: #1c1c1c;
            padding-bottom: 20px;
            span {
              font-weight: 400;
              font-size: 16px;
              color: #1c1c1c;
              margin-right: 12px;
              line-height: 22px;
            }
          }
        }
      }
    }
  }
}
</style>
